export const noResultsTextStyles = {
  "& .MuiTypography-root": {
    fontSize: "14px",
    color: "#9ca3af",
    fontStyle: "italic",
  },
}; 